import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { recordTypes } from "../../../../API/config";
import {
  CountryBasicData,
  CountryExchanges,
  CountryRegulators,
  CountryRiskData,
  CountryRiskDataRanges
} from "./Components";
import styles from "./styles";
import { useTranslation } from "react-i18next";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(styles);

export default function ScrollableTabsButtonAuto(props) {
  const { hasPermission } = props;
  const { t } = useTranslation();

  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [canViewCountries, setCanViewCountries] = useState();
  const [canViewCountryRegulators, setCanViewCountryRegulators] = useState();
  const [canViewCountryExchanges, setCanViewCountryExchanges] = useState();
  const [canViewCountryRiskData, setCanViewCountryRiskData] = useState();

  useEffect(() => {
    const evalPermissions = async () => {
      const canViewCountries = await hasPermission(
        recordTypes.country.name,
        recordTypes.country.actions.view.name
      );
      setCanViewCountries(canViewCountries);
      const canViewCountryRegulators = await hasPermission(
        recordTypes.countryRegulator.name,
        recordTypes.countryRegulator.actions.view.name
      );
      setCanViewCountryRegulators(canViewCountryRegulators);
      const canViewCountryExchanges = await hasPermission(
        recordTypes.countryExchange.name,
        recordTypes.countryExchange.actions.view.name
      );
      setCanViewCountryExchanges(canViewCountryExchanges);
      const canViewCountryRiskData = await hasPermission(
        recordTypes.countryRiskData.name,
        recordTypes.countryRiskData.actions.view.name
      );
      setCanViewCountryRiskData(canViewCountryRiskData);
    };

    evalPermissions();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.container}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        className={classes.tabStyle}
      >
        {canViewCountries && <Tab label={t("labels.country.basicInformation.header")} {...a11yProps(0)} />}
        {canViewCountryExchanges && <Tab label={t("labels.country.exchangeList.header")} {...a11yProps(1)} />}
        {canViewCountryRegulators && <Tab label={t("labels.country.regulatorList.header")} {...a11yProps(2)} />}
        {canViewCountryRiskData && <Tab label={t("labels.country.countryRiskData.header")} {...a11yProps(3)} />}
        {canViewCountryRiskData && <Tab label={t("labels.country.riskRangeData.header")} {...a11yProps(3)} />}
      </Tabs>

      <TabPanel value={value} index={0} className={classes.root}>
        <CountryBasicData hasPermission={hasPermission} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CountryExchanges hasPermission={hasPermission} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <CountryRegulators hasPermission={hasPermission} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <CountryRiskData hasPermission={hasPermission} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <CountryRiskDataRanges hasPermission={hasPermission} />
      </TabPanel>
    </div>
  );
}
